import { FormAtylBase } from '../../form-atyl-base'

export class AtylSignature extends FormAtylBase<string> {
	controlType = 'signature'
	type: string
	options: any

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
